import React, { useState, useEffect } from 'react';
import './Events.css';  // Adjust the path if needed

const FIREBASE_FUNCTION_URL = 'us-central1-gsp-website-553a2.cloudfunctions.net';

const Events = () => {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);

  // Helper function to format date to MM/DD/YYYY
  const formatDate = (dateString) => {
    // Ensure the input date string is in the format YYYY-MM-DD
    const [year, month, day] = dateString.split('-').map(Number);

    // Create a date object in the local timezone
    const date = new Date(year, month - 1, day);  // Month is zero-indexed

    // Format the date
    return new Intl.DateTimeFormat('en-US', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit'
    }).format(date);
  };

  useEffect(() => {
    // Fetch events from Firebase Cloud Function
    fetch(`https://${FIREBASE_FUNCTION_URL}/getEvents`)
      .then(response => response.json())
      .then(data => {
        const sortedEvents = data.sort((a, b) => new Date(a.date) - new Date(b.date));
        setEvents(sortedEvents);
        setLoading(false);
      })
      .catch(error => {
        console.error('Error fetching events:', error);
        setLoading(false);
      });
  }, []);

  return (
    <div className="events-container">
      <h1>UPCOMING EVENTS</h1>
      {loading ? <p>Loading events...</p> : (
        <div className="events-list">
          {events.length > 0 ? (
            events.map(event => (
              <div key={event.id} className="event-item">
                <h2>{event.title}</h2>
                <p className="event-date"><strong>Date:</strong> {formatDate(event.date)}</p>
                <p className="event-description">{event.description}</p>
                <a
                  href={event.registrationLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="register-link"
                >
                  Register Here
                </a>
              </div>
            ))
          ) : (
            <p>No upcoming events.</p>
          )}
        </div>
      )}
      <div className="past-events">
        <a href="/gallery" className="explore-events-btn">Check out our Past Events</a>
      </div>
    </div>
  );
};

export default Events;
